module.exports = __webpack_public_path__ + "assets/img/ic-copy.d4903448.svg";